import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/hu';
import DisabledFieldTooltip from './DisabledFieldTooltip';

const DatePickerUI = (props) => {
  const { variant, clearable, size } = props;
  const tooltipTitle =
    props.disabled && props.value && dayjs(props.value).isValid() ? dayjs(props.value).format('YYYY.MM.DD') : '';

  return (
    <DisabledFieldTooltip disabled={props.disabled} title={tooltipTitle}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="hu">
        <DatePicker
          slotProps={{
            textField: {
              variant: variant ?? 'standard',
              helperText: props.helperText,
              size: size ?? 'medium',
            },
            popper: {
              style: {
                zIndex: 9999,
              },
            },
            field: { clearable: clearable ?? true, onClear: () => {} },
          }}
          sx={{ width: '100%' }}
          {...props}
        />
      </LocalizationProvider>
    </DisabledFieldTooltip>
  );
};

export default DatePickerUI;
